import { debounce } from 'throttle-debounce';

export const preventDoubleClick = (fn: VoidFunction): VoidFunction =>
  // Время анимации слайдера
  debounce(1000, fn);
